import React from "react";
import MainLayout from "layouts/main.layout/main.layout";
import SplitLayout from "layouts/split.layout/split.layout";
import { useOutlet } from "react-router";
import DeviceBrandNavList from "components/list.components/nav.list.components/device.brand.nav.list.component/device.brand.nav.list.component";

const DeviceBrandPage = (): JSX.Element => {
  const outlet = useOutlet();

  return (
    <MainLayout>
      <SplitLayout
        useAsPage
        leftChild={<DeviceBrandNavList />}
        leftGrow={1}
        maxWidthLeft={550}
        minWidthLeft={350}
        rightChild={outlet}
        rightGrow={2}
      ></SplitLayout>
    </MainLayout>
  );
};

export default DeviceBrandPage;
